import React from 'react';
import { Circle, Rect } from 'react-konva';

export const DrawingRect = (props) => {
  const { x, y, width, height } = props.rect;
  return <Rect x={x} y={y} width={width} height={height} fill="#00000020" />;
};

export const DrawingCircle = (props) => {
  const { x, y, width, height } = props.rect;
  const { shiftPressing } = props;
  const maxWidth = Math.max(width, height);
  const scaleX = shiftPressing ? maxWidth / 2 : width / 2;
  const scaleY = shiftPressing ? maxWidth / 2 : height / 2;

  const edgeX = x + width / 2;
  const edgeY = y + height / 2;

  return <Circle x={edgeX} y={edgeY} radius={1} scaleX={scaleX} scaleY={scaleY} fill="#00000020" />;
};
